/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, {useRef, useEffect, useState, useContext} from 'react'
import { motion } from "framer-motion";
import SidePopup from '../../../../components/SidePopup'
import { useOnClickOutside } from '../../../../CommonMethods/OutsideClick';
import { dataService } from '../../../../services/data.services'
import { Link, useParams, useNavigate } from 'react-router-dom';
import AnimatedHeading from '../../../../components/Animation/AnimatedHeading';
import { FormattedNumber } from '../../../../CommonMethods/FormattedNumber';
import { CognitoData } from '../../../../CommonMethods/CognitoData';


const ViewBranchUser = ({handleSidePopupClick, openViewPopup, selectedbranchUserEmail, branchUserData, setbranchUserData,listOfRoles,loadingPage,heading,enableEdit,
    setOpenViewPopup}) => {
    const {id} = useParams()
    const navigate = useNavigate()
    const [userCognitoEmail, setUserCognitoEmail] = useState('');

    const ref3=useRef();
    useOnClickOutside(ref3,()=>{
        setOpenViewPopup(false)
    })

    /**
    * The function `getCurrentUserData` retrieves the current user's email from Cognito data and sets
    * it as the user's Cognito email.
    */
    const getCurrentUserData = async() => {
        const data = await CognitoData()
        setUserCognitoEmail(data.accessToken.payload.username)
    }
    useEffect(()=>{
        getCurrentUserData()
    },[])

    return (
        <>
            <SidePopup 
                class="bg-''"
                componentName={heading}
                handleSidePopupClick={handleSidePopupClick}
                setOpenViewPopup={setOpenViewPopup}
                loadingPage={loadingPage}
                isViewBranchUser={true}
                element={
                    <div class="offcanvas-body pt-6 overflow-y-auto pl-5 pr-2.5" ref={ref3}>
                        <div class="flex items-center justify-between mb-4 w-full">
                            <div class="w-full">
                                <AnimatedHeading className="text-f7 font-normal text-[#031624] pb-1" Children={"Full Name"} duration={1} />
                                <div class="flex items-center justify-between">
                                    <div class="flex items-center">
                                        <AnimatedHeading className="text-f7 font-semibold text-[#031624] break-words w-full" Children={`${branchUserData?.first_name} ${branchUserData?.last_name}`} duration={1} />
                                        
                                        {branchUserData?.status ?
                                            (<div className="rounded-lg bg-[#C5FFD5] flex items-center justify-center py-1 px-2.5 w-max ml-2">
                                                <img loading="lazy" decoding="async" src="/images/successDot.svg" alt="icon" />
                                                <span className="text-f7 font-normal text-[#031624] pl-1">Active</span>
                                            </div>)
                                            :
                                            (<div className="rounded-lg bg-[#B3BBC1] flex items-center justify-center py-1 px-2.5 w-max ml-4">
                                                <img loading="lazy" decoding="async" src="/images/inactive-Dot.svg" alt="icon" />
                                                <span className="text-f7 font-normal text-[#031624] pl-1">Inactive</span>
                                            </div>)
                                        }
                                    </div>
                                    {userCognitoEmail !== branchUserData?.email_address && branchUserData?.status && enableEdit && <Link to={(`/manage-branches/${id}*branch_users/edit-branch-user/${branchUserData?.email_address}`)}>
                                        <button type="button" class="edit_user_btn">
                                            <img src="/images/offcanvasEditDetails.svg" alt="img" class="w-[18px] min-w-[18px] ml-2.5" title="Edit Branch User"/>
                                        </button>
                                    </Link>}   
                                </div>
                            </div>
                        </div>
                        {branchUserData?.employee_number && <div class="mb-5">
                            <AnimatedHeading className="text-f7 font-normal text-[#031624] pb-1" Children={'Employee Number'} duration={1} />
                            <AnimatedHeading className="text-f7 font-semibold text-[#031624]" Children={branchUserData?.employee_number} duration={1}/>
                        </div>}
                        <div class="mb-5">
                            <AnimatedHeading className="text-f7 font-normal text-[#031624] pb-1" Children={'Email Address'} duration={1}/>
                            <AnimatedHeading className="text-f7 font-semibold text-[#031624]" Children={branchUserData?.email_address} duration={1} />
                        </div>
                        <div class="mb-5">
                            <AnimatedHeading className="text-f7 font-normal text-[#031624] pb-1" Children={'Mobile Number'} duration={1} />
                            <AnimatedHeading className="text-f7 font-semibold text-[#031624]" Children={FormattedNumber(branchUserData?.mobile_number)} duration={1} />
                        </div>
                        <AnimatedHeading className="text-f7 font-semibold text-[#031624] pb-2" Children={'Roles'}  duration={1}/>
                        <motion.div 
                            className="border border-[#95C0E0] rounded bg-[#fff] p-2"
                            initial={{ opacity: 0, y: 0 }} // Initial state of the heading
                            animate={{ opacity: 1, y: 0 }} // Final state of the heading
                            transition={{ duration: 1 }} // Animation duration
                        >
                            <div className="overflow-auto max-h-[208px] scroll-bar">
                                <div className="pr-1">
                                    <div className="-mx-1 flex-wrap flex">
                                        {Object(listOfRoles)?.length !== undefined && listOfRoles.map(role => {
                                            const roleName = Object.keys(role)[0];
                                            const items = role[roleName];
                                            return (
                                                <div className="w-1/2 mb-3 px-1" key={roleName}>
                                                    <div className="w-full">
                                                        <p className="text-f7 font-semibold text-[#031624] pb-2">{roleName}</p>
                                                        {items.map(item => (
                                                            <p key={item} class="text-f7 font-normal text-[#031624] pb-1 ml-2">{item}</p>                                        
                                                        ))}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    </div>
                }
            />
        </>
    )
}

export default ViewBranchUser